import { render, staticRenderFns } from "./FoodDistributionFamilies.vue?vue&type=template&id=467786da&"
import script from "./FoodDistributionFamilies.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionFamilies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports